var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"antv-chart-mini"},[_c('div',{staticClass:"chart-wrapper trend",style:({ height: _vm.height })},[_c('v-chart',{attrs:{"force-fit":true,"height":_vm.height,"data":_vm.data,"padding":"auto"}},[_c('v-tooltip',{attrs:{"showTitle":false}}),_c('v-smooth-area',{attrs:{"position":"x*y","tooltip":_vm.tooltipConfig}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }